/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './model';
import '../../common/location';
import '../../connect/v2/resources/error';
import '../../panhandler/service';
import '../../common/currency';
import './digital_wallet_configuration';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cardr": {
        "nested": {
          "issuing": {
            "nested": {
              "IssueCardRequest": {
                "fields": {
                  "issuerProcessor": {
                    "type": ".squareup.cardr.issuing.IssuerProcessor",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "nameOnCard": {
                    "type": ".squareup.cardr.issuing.CardHolderName",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 5,
                    "rule": "optional"
                  },
                  "businessInfo": {
                    "type": ".squareup.cardr.issuing.BusinessInfo",
                    "id": 6,
                    "rule": "optional"
                  },
                  "creditCardInfo": {
                    "type": ".squareup.cardr.issuing.CreditCardInfo",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardLocationIds": {
                    "type": "string",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "backingAccountToken": {
                    "type": ".squareup.cardr.issuing.BackingAccountToken",
                    "id": 9,
                    "rule": "optional"
                  },
                  "accountHolderToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "cardHolderEmailAddress": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "IssueCardResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReissueCardRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": ".squareup.cardr.issuing.ReissueCardReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ReissueCardResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ActivateCardRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "manualEntry": {
                    "type": ".squareup.cardr.issuing.ActivateCardRequest.ManualEntry",
                    "id": 4
                  },
                  "deepLink": {
                    "type": ".squareup.cardr.issuing.ActivateCardRequest.DeepLink",
                    "id": 5
                  },
                  "adminAction": {
                    "type": ".squareup.cardr.issuing.ActivateCardRequest.AdminAction",
                    "id": 6
                  }
                },
                "nested": {
                  "ManualEntry": {
                    "fields": {
                      "expiryDate": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "securityCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "DeepLink": {
                    "fields": {
                      "carrierId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardReferenceNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AdminAction": {
                    "fields": {}
                  },
                  "method": {
                    "oneof": ["manualEntry", "deepLink", "adminAction"]
                  }
                }
              },
              "ActivateCardResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetIssuedCardRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetIssuedCardResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetIssuedCardLimitedFieldsRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetIssuedCardLimitedFieldsResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetInternalIssuedCardRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetInternalIssuedCardResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetIssuedCardEncryptedTenderRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetIssuedCardEncryptedTenderResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.cardr.issuing.GetIssuedCardEncryptedTenderResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedTender": {
                    "type": ".squareup.panhandler.service.ServerEncryptedTender",
                    "id": 2,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "RESULT_UNKNOWN_DO_NOT_USE": 0,
                      "OK": 1,
                      "NOT_FOUND": 2
                    }
                  }
                }
              },
              "SetCardStateRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetCardStateResponse": {
                "fields": {
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateProfileRequest": {
                "fields": {
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardHolderEmailAddress": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "UpdateProfileResponse": {
                "fields": {
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateInternalCardRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardLocationIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateInternalCardResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreditFundsRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creditType": {
                    "type": ".squareup.cardr.issuing.CreditFundsRequest.Type",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "CFT_DO_NOT_USE": 0,
                      "ACH_PAYMENT": 1,
                      "POS_WITHHOLDING_PAYMENT": 2,
                      "OUTSTANDING_BALANCE_DECREASE": 3
                    }
                  }
                }
              },
              "CreditFundsResponse": {
                "fields": {
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "DebitFundsRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "debitType": {
                    "type": ".squareup.cardr.issuing.DebitFundsRequest.Type",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DEFAULT": 0,
                      "OUTSTANDING_BALANCE_INCREASE": 1
                    }
                  }
                }
              },
              "DebitFundsResponse": {
                "fields": {
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ReverseTransactionRequest": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ReverseTransactionResponse": {
                "fields": {
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListIssuedCardsRequest": {
                "fields": {
                  "filter": {
                    "type": ".squareup.cardr.issuing.ListIssuedCardsRequest.Filter",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filter": {
                    "fields": {
                      "externalCardTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "cardHolderTokens": {
                        "type": ".squareup.cardr.issuing.CardHolderToken",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "ListIssuedCardsResponse": {
                "fields": {
                  "issuedCards": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ProvisionApplePayRequest": {
                "fields": {
                  "request": {
                    "type": ".squareup.cardr.issuing.DigitalWalletProvisionApplePayRequest",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardrCardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ProvisionApplePayResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.cardr.issuing.ProvisionApplePayResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.cardr.issuing.ProvisionApplePayResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "response": {
                        "type": ".squareup.cardr.issuing.DigitalWalletProvisionApplePayResponse",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "UpdateCreditLimitRequest": {
                "fields": {
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateCreditLimitResponse": {
                "fields": {
                  "issuedCard": {
                    "type": ".squareup.cardr.issuing.IssuedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "IssuedCardService": {
                "methods": {
                  "ActivateCard": {
                    "requestType": ".squareup.cardr.issuing.ActivateCardRequest",
                    "responseType": ".squareup.cardr.issuing.ActivateCardResponse"
                  },
                  "IssueCard": {
                    "requestType": ".squareup.cardr.issuing.IssueCardRequest",
                    "responseType": ".squareup.cardr.issuing.IssueCardResponse"
                  },
                  "ReissueCard": {
                    "requestType": ".squareup.cardr.issuing.ReissueCardRequest",
                    "responseType": ".squareup.cardr.issuing.ReissueCardResponse"
                  },
                  "GetIssuedCard": {
                    "requestType": ".squareup.cardr.issuing.GetIssuedCardRequest",
                    "responseType": ".squareup.cardr.issuing.GetIssuedCardResponse"
                  },
                  "GetIssuedCardLimitedFields": {
                    "requestType": ".squareup.cardr.issuing.GetIssuedCardLimitedFieldsRequest",
                    "responseType": ".squareup.cardr.issuing.GetIssuedCardLimitedFieldsResponse"
                  },
                  "GetInternalIssuedCard": {
                    "requestType": ".squareup.cardr.issuing.GetInternalIssuedCardRequest",
                    "responseType": ".squareup.cardr.issuing.GetInternalIssuedCardResponse"
                  },
                  "GetIssuedCardEncryptedTender": {
                    "requestType": ".squareup.cardr.issuing.GetIssuedCardEncryptedTenderRequest",
                    "responseType": ".squareup.cardr.issuing.GetIssuedCardEncryptedTenderResponse"
                  },
                  "SetCardState": {
                    "requestType": ".squareup.cardr.issuing.SetCardStateRequest",
                    "responseType": ".squareup.cardr.issuing.SetCardStateResponse"
                  },
                  "UpdateProfile": {
                    "requestType": ".squareup.cardr.issuing.UpdateProfileRequest",
                    "responseType": ".squareup.cardr.issuing.UpdateProfileResponse"
                  },
                  "UpdateInternalCard": {
                    "requestType": ".squareup.cardr.issuing.UpdateInternalCardRequest",
                    "responseType": ".squareup.cardr.issuing.UpdateInternalCardResponse"
                  },
                  "CreditFunds": {
                    "requestType": ".squareup.cardr.issuing.CreditFundsRequest",
                    "responseType": ".squareup.cardr.issuing.CreditFundsResponse"
                  },
                  "DebitFunds": {
                    "requestType": ".squareup.cardr.issuing.DebitFundsRequest",
                    "responseType": ".squareup.cardr.issuing.DebitFundsResponse"
                  },
                  "ReverseTransaction": {
                    "requestType": ".squareup.cardr.issuing.ReverseTransactionRequest",
                    "responseType": ".squareup.cardr.issuing.ReverseTransactionResponse"
                  },
                  "ListIssuedCards": {
                    "requestType": ".squareup.cardr.issuing.ListIssuedCardsRequest",
                    "responseType": ".squareup.cardr.issuing.ListIssuedCardsResponse"
                  },
                  "ProvisionApplePay": {
                    "requestType": ".squareup.cardr.issuing.ProvisionApplePayRequest",
                    "responseType": ".squareup.cardr.issuing.ProvisionApplePayResponse"
                  },
                  "UpdateCreditLimit": {
                    "requestType": ".squareup.cardr.issuing.UpdateCreditLimitRequest",
                    "responseType": ".squareup.cardr.issuing.UpdateCreditLimitResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssueCardRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssueCardResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ReissueCardRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ReissueCardResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ActivateCardRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ActivateCardRequest?.nested?.ManualEntry && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ActivateCardRequest?.nested?.DeepLink && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ActivateCardRequest?.nested?.AdminAction && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ActivateCardResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardLimitedFieldsRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardLimitedFieldsResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetInternalIssuedCardRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetInternalIssuedCardResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardEncryptedTenderRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardEncryptedTenderResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.GetIssuedCardEncryptedTenderResponse?.nested?.Result && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.SetCardStateRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.SetCardStateResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.UpdateProfileRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.UpdateProfileResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.UpdateInternalCardRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.UpdateInternalCardResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CreditFundsRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CreditFundsRequest?.nested?.Type && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CreditFundsResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.DebitFundsRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.DebitFundsRequest?.nested?.Type && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.DebitFundsResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ReverseTransactionRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ReverseTransactionResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ListIssuedCardsRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ListIssuedCardsRequest?.nested?.Filter && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ListIssuedCardsResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ProvisionApplePayRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ProvisionApplePayResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ProvisionApplePayResponse?.nested?.Success && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ProvisionApplePayResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.UpdateCreditLimitRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.UpdateCreditLimitResponse && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssuedCardService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE IssueCardRequest @ squareup/cardr/issuing/service.proto at 19:1
 */
export const IssueCardRequest = $root.lookupType('squareup.cardr.issuing.IssueCardRequest');
fixType(IssueCardRequest, {
  issuerProcessor: {
    required: true
  },
  idempotencyToken: {
    required: true
  },
  cardHolderToken: {
    required: true
  }
});
Builder.createAndAttachToType(IssueCardRequest);
/**
 * SOURCE IssueCardResponse @ squareup/cardr/issuing/service.proto at 54:1
 */
export const IssueCardResponse = $root.lookupType('squareup.cardr.issuing.IssueCardResponse');
fixType(IssueCardResponse);
Builder.createAndAttachToType(IssueCardResponse);
/**
 * SOURCE ReissueCardRequest @ squareup/cardr/issuing/service.proto at 61:1
 */
export const ReissueCardRequest = $root.lookupType('squareup.cardr.issuing.ReissueCardRequest');
fixType(ReissueCardRequest, {
  cardrCardToken: {
    required: true
  },
  reasonCode: {
    required: true
  }
});
Builder.createAndAttachToType(ReissueCardRequest);
/**
 * SOURCE ReissueCardResponse @ squareup/cardr/issuing/service.proto at 75:1
 */
export const ReissueCardResponse = $root.lookupType('squareup.cardr.issuing.ReissueCardResponse');
fixType(ReissueCardResponse);
Builder.createAndAttachToType(ReissueCardResponse);
/**
 * SOURCE ActivateCardRequest @ squareup/cardr/issuing/service.proto at 82:1
 */
export const ActivateCardRequest = $root.lookupType('squareup.cardr.issuing.ActivateCardRequest');
fixType(ActivateCardRequest, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(ActivateCardRequest);
/**
 * Submitted manually-entered values to be compared against the actual value.
 *
 * SOURCE ManualEntry @ squareup/cardr/issuing/service.proto at 95:3
 */
ActivateCardRequest.ManualEntry = $root.lookupType('squareup.cardr.issuing.ActivateCardRequest.ManualEntry');
fixType(ActivateCardRequest.ManualEntry, {
  expiryDate: {
    notEmpty: true
  },
  securityCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActivateCardRequest.ManualEntry);
/**
 * Params from the QR code on the physical credit card's mailer.
 *
 * SOURCE DeepLink @ squareup/cardr/issuing/service.proto at 105:3
 */
ActivateCardRequest.DeepLink = $root.lookupType('squareup.cardr.issuing.ActivateCardRequest.DeepLink');
fixType(ActivateCardRequest.DeepLink, {
  cardReferenceNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActivateCardRequest.DeepLink);
/**
 * Admin action that is usally taken by our Ops Team to service customer requests
 *
 * SOURCE AdminAction @ squareup/cardr/issuing/service.proto at 113:3
 */
ActivateCardRequest.AdminAction = $root.lookupType('squareup.cardr.issuing.ActivateCardRequest.AdminAction');
fixType(ActivateCardRequest.AdminAction);
Builder.createAndAttachToType(ActivateCardRequest.AdminAction);
/**
 * SOURCE ActivateCardResponse @ squareup/cardr/issuing/service.proto at 117:1
 */
export const ActivateCardResponse = $root.lookupType('squareup.cardr.issuing.ActivateCardResponse');
fixType(ActivateCardResponse);
Builder.createAndAttachToType(ActivateCardResponse);
/**
 * SOURCE GetIssuedCardRequest @ squareup/cardr/issuing/service.proto at 125:1
 */
export const GetIssuedCardRequest = $root.lookupType('squareup.cardr.issuing.GetIssuedCardRequest');
fixType(GetIssuedCardRequest, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetIssuedCardRequest);
/**
 * SOURCE GetIssuedCardResponse @ squareup/cardr/issuing/service.proto at 130:1
 */
export const GetIssuedCardResponse = $root.lookupType('squareup.cardr.issuing.GetIssuedCardResponse');
fixType(GetIssuedCardResponse);
Builder.createAndAttachToType(GetIssuedCardResponse);
/**
 * SOURCE GetIssuedCardLimitedFieldsRequest @ squareup/cardr/issuing/service.proto at 137:1
 */
export const GetIssuedCardLimitedFieldsRequest = $root.lookupType('squareup.cardr.issuing.GetIssuedCardLimitedFieldsRequest');
fixType(GetIssuedCardLimitedFieldsRequest, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetIssuedCardLimitedFieldsRequest);
/**
 * SOURCE GetIssuedCardLimitedFieldsResponse @ squareup/cardr/issuing/service.proto at 142:1
 */
export const GetIssuedCardLimitedFieldsResponse = $root.lookupType('squareup.cardr.issuing.GetIssuedCardLimitedFieldsResponse');
fixType(GetIssuedCardLimitedFieldsResponse);
Builder.createAndAttachToType(GetIssuedCardLimitedFieldsResponse);
/**
 * SOURCE GetInternalIssuedCardRequest @ squareup/cardr/issuing/service.proto at 151:1
 */
export const GetInternalIssuedCardRequest = $root.lookupType('squareup.cardr.issuing.GetInternalIssuedCardRequest');
fixType(GetInternalIssuedCardRequest, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetInternalIssuedCardRequest);
/**
 * SOURCE GetInternalIssuedCardResponse @ squareup/cardr/issuing/service.proto at 156:1
 */
export const GetInternalIssuedCardResponse = $root.lookupType('squareup.cardr.issuing.GetInternalIssuedCardResponse');
fixType(GetInternalIssuedCardResponse);
Builder.createAndAttachToType(GetInternalIssuedCardResponse);
/**
 * SOURCE GetIssuedCardEncryptedTenderRequest @ squareup/cardr/issuing/service.proto at 163:1
 */
export const GetIssuedCardEncryptedTenderRequest = $root.lookupType('squareup.cardr.issuing.GetIssuedCardEncryptedTenderRequest');
fixType(GetIssuedCardEncryptedTenderRequest, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetIssuedCardEncryptedTenderRequest);
/**
 * SOURCE GetIssuedCardEncryptedTenderResponse @ squareup/cardr/issuing/service.proto at 168:1
 */
export const GetIssuedCardEncryptedTenderResponse = $root.lookupType('squareup.cardr.issuing.GetIssuedCardEncryptedTenderResponse');
fixType(GetIssuedCardEncryptedTenderResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(GetIssuedCardEncryptedTenderResponse);
/**
 * The response result
 *
 * SOURCE Result @ squareup/cardr/issuing/service.proto at 170:3
 */
GetIssuedCardEncryptedTenderResponse.Result = $root.lookupEnum('squareup.cardr.issuing.GetIssuedCardEncryptedTenderResponse.Result').values;
/**
 * SOURCE SetCardStateRequest @ squareup/cardr/issuing/service.proto at 190:1
 */
export const SetCardStateRequest = $root.lookupType('squareup.cardr.issuing.SetCardStateRequest');
fixType(SetCardStateRequest, {
  cardrCardToken: {
    required: true
  },
  state: {
    required: true
  }
});
Builder.createAndAttachToType(SetCardStateRequest);
/**
 * SOURCE SetCardStateResponse @ squareup/cardr/issuing/service.proto at 198:1
 */
export const SetCardStateResponse = $root.lookupType('squareup.cardr.issuing.SetCardStateResponse');
fixType(SetCardStateResponse);
Builder.createAndAttachToType(SetCardStateResponse);
/**
 * SOURCE UpdateProfileRequest @ squareup/cardr/issuing/service.proto at 205:1
 */
export const UpdateProfileRequest = $root.lookupType('squareup.cardr.issuing.UpdateProfileRequest');
fixType(UpdateProfileRequest, {
  cardHolderToken: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateProfileRequest);
/**
 * SOURCE UpdateProfileResponse @ squareup/cardr/issuing/service.proto at 219:1
 */
export const UpdateProfileResponse = $root.lookupType('squareup.cardr.issuing.UpdateProfileResponse');
fixType(UpdateProfileResponse);
Builder.createAndAttachToType(UpdateProfileResponse);
/**
 * SOURCE UpdateInternalCardRequest @ squareup/cardr/issuing/service.proto at 227:1
 */
export const UpdateInternalCardRequest = $root.lookupType('squareup.cardr.issuing.UpdateInternalCardRequest');
fixType(UpdateInternalCardRequest, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateInternalCardRequest);
/**
 * SOURCE UpdateInternalCardResponse @ squareup/cardr/issuing/service.proto at 238:1
 */
export const UpdateInternalCardResponse = $root.lookupType('squareup.cardr.issuing.UpdateInternalCardResponse');
fixType(UpdateInternalCardResponse);
Builder.createAndAttachToType(UpdateInternalCardResponse);
/**
 * SOURCE CreditFundsRequest @ squareup/cardr/issuing/service.proto at 245:1
 */
export const CreditFundsRequest = $root.lookupType('squareup.cardr.issuing.CreditFundsRequest');
fixType(CreditFundsRequest, {
  amount: {
    required: true
  },
  idempotencyToken: {
    required: true
  },
  cardHolderToken: {
    required: true
  }
});
Builder.createAndAttachToType(CreditFundsRequest);
/**
 * SOURCE Type @ squareup/cardr/issuing/service.proto at 246:3
 */
CreditFundsRequest.Type = $root.lookupEnum('squareup.cardr.issuing.CreditFundsRequest.Type').values;
/**
 * SOURCE CreditFundsResponse @ squareup/cardr/issuing/service.proto at 269:1
 */
export const CreditFundsResponse = $root.lookupType('squareup.cardr.issuing.CreditFundsResponse');
fixType(CreditFundsResponse);
Builder.createAndAttachToType(CreditFundsResponse);
/**
 * SOURCE DebitFundsRequest @ squareup/cardr/issuing/service.proto at 276:1
 */
export const DebitFundsRequest = $root.lookupType('squareup.cardr.issuing.DebitFundsRequest');
fixType(DebitFundsRequest, {
  amount: {
    required: true
  },
  idempotencyToken: {
    required: true
  }
});
Builder.createAndAttachToType(DebitFundsRequest);
/**
 * SOURCE Type @ squareup/cardr/issuing/service.proto at 277:3
 */
DebitFundsRequest.Type = $root.lookupEnum('squareup.cardr.issuing.DebitFundsRequest.Type').values;
/**
 * SOURCE DebitFundsResponse @ squareup/cardr/issuing/service.proto at 298:1
 */
export const DebitFundsResponse = $root.lookupType('squareup.cardr.issuing.DebitFundsResponse');
fixType(DebitFundsResponse);
Builder.createAndAttachToType(DebitFundsResponse);
/**
 * SOURCE ReverseTransactionRequest @ squareup/cardr/issuing/service.proto at 305:1
 */
export const ReverseTransactionRequest = $root.lookupType('squareup.cardr.issuing.ReverseTransactionRequest');
fixType(ReverseTransactionRequest, {
  amount: {
    required: true
  },
  transactionToken: {
    required: true
  },
  idempotencyToken: {
    required: true
  }
});
Builder.createAndAttachToType(ReverseTransactionRequest);
/**
 * SOURCE ReverseTransactionResponse @ squareup/cardr/issuing/service.proto at 322:1
 */
export const ReverseTransactionResponse = $root.lookupType('squareup.cardr.issuing.ReverseTransactionResponse');
fixType(ReverseTransactionResponse);
Builder.createAndAttachToType(ReverseTransactionResponse);
/**
 * SOURCE ListIssuedCardsRequest @ squareup/cardr/issuing/service.proto at 329:1
 */
export const ListIssuedCardsRequest = $root.lookupType('squareup.cardr.issuing.ListIssuedCardsRequest');
fixType(ListIssuedCardsRequest, {
  filter: {
    required: true
  }
});
Builder.createAndAttachToType(ListIssuedCardsRequest);
/**
 * SOURCE Filter @ squareup/cardr/issuing/service.proto at 330:3
 */
ListIssuedCardsRequest.Filter = $root.lookupType('squareup.cardr.issuing.ListIssuedCardsRequest.Filter');
fixType(ListIssuedCardsRequest.Filter);
Builder.createAndAttachToType(ListIssuedCardsRequest.Filter);
/**
 * SOURCE ListIssuedCardsResponse @ squareup/cardr/issuing/service.proto at 341:1
 */
export const ListIssuedCardsResponse = $root.lookupType('squareup.cardr.issuing.ListIssuedCardsResponse');
fixType(ListIssuedCardsResponse);
Builder.createAndAttachToType(ListIssuedCardsResponse);
/**
 * SOURCE ProvisionApplePayRequest @ squareup/cardr/issuing/service.proto at 349:1
 */
export const ProvisionApplePayRequest = $root.lookupType('squareup.cardr.issuing.ProvisionApplePayRequest');
fixType(ProvisionApplePayRequest, {
  request: {
    required: true
  },
  cardrCardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ProvisionApplePayRequest);
/**
 * SOURCE ProvisionApplePayResponse @ squareup/cardr/issuing/service.proto at 357:1
 */
export const ProvisionApplePayResponse = $root.lookupType('squareup.cardr.issuing.ProvisionApplePayResponse');
fixType(ProvisionApplePayResponse);
Builder.createAndAttachToType(ProvisionApplePayResponse);
/**
 * SOURCE Success @ squareup/cardr/issuing/service.proto at 358:3
 */
ProvisionApplePayResponse.Success = $root.lookupType('squareup.cardr.issuing.ProvisionApplePayResponse.Success');
fixType(ProvisionApplePayResponse.Success, {
  response: {
    required: true
  }
});
Builder.createAndAttachToType(ProvisionApplePayResponse.Success);
/**
 * SOURCE Failure @ squareup/cardr/issuing/service.proto at 363:3
 */
ProvisionApplePayResponse.Failure = $root.lookupType('squareup.cardr.issuing.ProvisionApplePayResponse.Failure');
fixType(ProvisionApplePayResponse.Failure);
Builder.createAndAttachToType(ProvisionApplePayResponse.Failure);
/**
 * SOURCE UpdateCreditLimitRequest @ squareup/cardr/issuing/service.proto at 373:1
 */
export const UpdateCreditLimitRequest = $root.lookupType('squareup.cardr.issuing.UpdateCreditLimitRequest');
fixType(UpdateCreditLimitRequest, {
  cardHolderToken: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateCreditLimitRequest);
/**
 * SOURCE UpdateCreditLimitResponse @ squareup/cardr/issuing/service.proto at 381:1
 */
export const UpdateCreditLimitResponse = $root.lookupType('squareup.cardr.issuing.UpdateCreditLimitResponse');
fixType(UpdateCreditLimitResponse);
Builder.createAndAttachToType(UpdateCreditLimitResponse);
/**
 * Card Management service for cards.
 * These cards can be issued by third party vendors (eg. i2C),
 * -> Which will act as a gateway to the external card vendor
 * or internal to Square (CustomerBalance cards)
 * -> Which will be a card saved in cardr's DB
 *
 * Card Management should ideally be focused on the Card entity, like creating or deactivating cards,
 * and not on the card's payment transactions or balance changes.
 *
 * SOURCE IssuedCardService @ squareup/cardr/issuing/service.proto at 398:1
 */
export const IssuedCardService = $root.lookupService('squareup.cardr.issuing.IssuedCardService');